module.exports = __webpack_public_path__ + "img/chevron-up-light.620a8428.svg";